import 'twin.macro';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';
import { Divider } from 'components/Divider';
import { Plans } from './Plans';
import { Totaux } from './Totaux';
import { Cart } from './types';
import { Plan } from '@teetsh/app/src/types/plan';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

interface SubscriptionCheckoutProps {
  plansTitle: string;
  cart: Cart;
  onCartChange: (cart: Cart) => void;
  plans: Plan[];
  controls: ReactNode;
}

export function SubscriptionCheckout({
  plansTitle,
  cart,
  onCartChange,
  plans,
  controls,
}: SubscriptionCheckoutProps) {
  const { t } = useTranslation(['userSettings']);
  return (
    <TwoColumnsCardSidebar.Container>
      <div tw="flex flex-col gap-8">
        <TwoColumnsCardSidebar.Section
          title={plansTitle}
          subtitle={t('userSettings:schoolSubscription.subtitle')}
          blank
          padding={false}
        >
          <Plans cart={cart} onChange={onCartChange} plans={plans} />
        </TwoColumnsCardSidebar.Section>

        <Divider />

        <TwoColumnsCardSidebar.Section title={t('licences.title.yourOrder')}>
          <Totaux plans={plans} cart={cart} />
          {controls}
        </TwoColumnsCardSidebar.Section>
      </div>
    </TwoColumnsCardSidebar.Container>
  );
}
